import { Middleware } from 'redux';
import { RootState } from '../reducers';
import { TwsActionTypes } from '../../utils/types';

// type TWsActionTypes = AnyAction;

export const socketMiddleware =
    (wsActions: TwsActionTypes): Middleware<{}, RootState> =>
    (store) => {
        let socket: WebSocket | null = null;
        let isConnected = false;
        let reconnectTimer = 0;
        let url = '';

        return (next) => (action) => {
            const { dispatch } = store; // , getState } = store;
            const { payload } = action;
            const {
                wsConnect,
                wsSendMessage,
                wsConnecting,
                wsDisconnect,
                onOpen,
                onClose,
                onError,
                onMessage,
            } = wsActions;
            // const { user, accessToken } = getState().auth;

            if (wsConnect.match(action)) {
                url = payload;
                socket = new WebSocket(url);
                isConnected = true;
                dispatch(wsConnecting());
            }
            if (socket) {
                socket.onopen = () => {
                    dispatch(onOpen());
                };

                socket.onerror = () => {
                    dispatch(onError('Error'));
                };

                socket.onmessage = (event) => {
                    const { data } = event;
                    const parsedData = JSON.parse(data);
                    // const { success, ...restParsedData } = parsedData;
                    dispatch(onMessage(parsedData));
                };

                socket.onclose = () => {
                    dispatch(onClose());
                    if (isConnected) {
                        dispatch(wsConnecting());
                        reconnectTimer = window.setTimeout(() => {
                            dispatch(wsConnect(url));
                        }, 3000);
                    }
                };

                if (wsSendMessage?.match(action)) {
                    const message = { ...action.payload }; // , token: accessToken };
                    socket.send(JSON.stringify(message));
                }
                if (wsDisconnect.match(action)) {
                    clearTimeout(reconnectTimer);
                    isConnected = false;
                    reconnectTimer = 0;
                    socket.close();
                    socket = null;
                }
            }

            next(action);
        };
    };

export default socketMiddleware;
